var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"size":"sm","icon":"","variant":"link"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('b-icon',{staticClass:"font-size-16",attrs:{"variant":"danger","icon":"x-circle-fill"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }